import PropTypes from "prop-types";
import { StarRatingButton, StarRatingGroup } from "../index";
import { RATINGS_WITHOUT_REVIEWS_TEXT } from "../ratingTypes";
import useRatingsFeatureRequirements from "../../../hooks/ratingsFeatureRequirements/useRatingsFeatureRequirements";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./Rating.scss";

function renderRatings({ displayRatingsSection, ratingsProps, productLink }) {
  const ratingGroup = (
    <StarRatingGroup {...ratingsProps} type={RATINGS_WITHOUT_REVIEWS_TEXT} />
  );

  if (displayRatingsSection) {
    return <StarRatingButton {...ratingsProps} />;
  }

  if (productLink) {
    return (
      <a href={productLink} className={styles.productLink}>
        {ratingGroup}
      </a>
    );
  }

  return ratingGroup;
}

export default function Rating({ ratingsFromProduct, productLink, isInStock }) {
  const { webContext, ratings } = useRuntimeConstants();
  const ratingsFeatureRequirementsAchieved = useRatingsFeatureRequirements(
    ratingsFromProduct ? ratingsFromProduct : ratings,
    isInStock
  );

  if (!ratingsFeatureRequirementsAchieved) {
    return null;
  }

  const {
    averageOverallStarRating,
    averageOverallRating,
    totalReviewCount,
    displayRatingsSection,
  } = ratingsFromProduct ?? ratings;

  const ratingsProps = {
    averageOverallStarRating,
    averageOverallRating,
    totalReviewCount,
    language: webContext.browseLanguage,
  };

  return (
    <>
      {renderRatings({
        displayRatingsSection,
        ratingsProps,
        productLink,
      })}
    </>
  );
}

Rating.propTypes = {
  ratingsFromProduct: PropTypes.shape({
    averageOverallRating: PropTypes.number,
    averageOverallStarRating: PropTypes.number,
    totalReviewCount: PropTypes.number,
  }),
  productLink: PropTypes.string,
  isInStock: PropTypes.bool,
};
